import { render, staticRenderFns } from "./meal-card.vue?vue&type=template&id=31dab852&scoped=true&"
import script from "./meal-card.vue?vue&type=script&lang=js&"
export * from "./meal-card.vue?vue&type=script&lang=js&"
import style0 from "./meal-card.vue?vue&type=style&index=0&id=31dab852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dab852",
  null
  
)

export default component.exports